import React, { useEffect, useState } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Card } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import * as actions from '../actions';
import * as selectors from '../selectors';

import EmptyState from './EmptyState';
import FilterOptions from './FilterOptions';
import ItemsList from './ItemsList';
import ReportModal from './ReportModal';

const CardContent = ({
    canDelete,
    canModify,
    consumptionHistory,
    consumptionHistoryPagination,
    fetchData,
    isLoading,
    prepareCreate,
    projectId,
    setReportModalOpenStatus,
    yearsForSelect,
}) => {
    const [year, setYear] = useState('');
    const { t } = useTranslation();

    useEffect(() => {
        fetchData({ isInitialFetch: true, projectId });
    }, [projectId]);

    const handleOnFilter = (value) => {
        setYear(value);
        fetchData({ isInitialFetch: true, projectId, year: value });
    };

    const addButton = (
        <Button
            endIcon={<AddIcon />}
            onClick={prepareCreate}
            variant="outlined"
        >
            {t('Add')}
        </Button>
    );

    return (
        <>
            <Card.Body>
                <FilterOptions
                    handleOnFilter={handleOnFilter}
                    options={yearsForSelect}
                />
                {consumptionHistory.length > 0 || isLoading ? (
                    <ItemsList
                        canDelete={canDelete}
                        canModify={canModify}
                        consumptionHistoryPagination={
                            consumptionHistoryPagination
                        }
                        isLoading={isLoading}
                        items={consumptionHistory}
                        projectId={projectId}
                        year={year}
                    />
                ) : (
                    <EmptyState addButton={addButton} canModify={canModify} />
                )}
            </Card.Body>
            {canModify && consumptionHistory.length > 0 && (
                <Card.Actions>
                    <Box textAlign="right" sx={{ width: '100%' }}>
                        {addButton}
                    </Box>
                </Card.Actions>
            )}

            <ReportModal
                handleOnClose={() => setReportModalOpenStatus(false)}
            />
        </>
    );
};

CardContent.propTypes = {
    canDelete: PropTypes.bool,
    canModify: PropTypes.bool,
    consumptionHistory: PropTypes.array,
    consumptionHistoryPagination: PropTypes.object,
    fetchData: PropTypes.func,
    isLoading: PropTypes.bool,
    prepareCreate: PropTypes.func,
    projectId: PropTypes.string,
    setReportModalOpenStatus: PropTypes.func,
    yearsForSelect: PropTypes.array,
};

const mapStateToProps = createStructuredSelector({
    consumptionHistory: selectors.getConsumptionHistoryItems,
    consumptionHistoryPagination: selectors.getConsumptionHistoryPagination,
    isLoading: selectors.getConsumptionHistoryIsLoading,
    yearsForSelect: selectors.getConsumptionHistoryYearsForSelect,
});

const mapDispatchToProps = (dispatch) => ({
    fetchData: (params) => dispatch(actions.fetchData(params)),
    prepareCreate: (value) => dispatch(actions.prepareCreate(value)),
    setReportModalOpenStatus: (value) =>
        dispatch(actions.setReportModalOpenStatus(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardContent);
